/* eslint-disable class-methods-use-this, no-console */
import React from 'react';
import * as Sentry from '@sentry/browser';
import P from 'prop-types';

import ErrorPage from '../pages/ErrorPage/ErrorPage';
import { W } from '../i18n';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

class RootErrorBoundary extends React.Component<Props, State> {
  static propTypes = {
    children: P.node.isRequired,
  };

  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error });

    const { enableSentry } = window.__config__;
    if (enableSentry) {
      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          // @ts-ignore
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorPage
          title={
            <div>
              {W('shared.pages.error.somethingWentWrong')}
              <br />
              {W('shared.pages.error.errorsHaveBeenReported')}
            </div>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default RootErrorBoundary;
